import { Model } from 'app/model/backendmodel';
import { AdapterRegistry } from 'shell-models-lib';
import { Metamodel } from 'app/model/base/model';
import { CommonDataServiceEntityDataset } from 'app/model/dataset/common-data-service.dataset';
import { TabularTypeDatasetAdapter } from './tabular-type.dataset.adapter';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(CommonDataServiceEntityDataset),
    asynchronous: true,
    adapts: {
        name: '*',
        properties: {
            description: '*',
            folder: '*',
            annotations: '*',
            schema: '*',
            linkedServiceName: '*',
            parameters: '*',
            type: '*',
            typeProperties: {
                entityName: '*'
            }
        }
    }
})
export class CommonDataServiceEntityDatasetAdapter extends TabularTypeDatasetAdapter<CommonDataServiceEntityDataset, Model.DatasetResource> {
    protected async _toResource(dataset: CommonDataServiceEntityDataset): Promise<Model.DatasetResource> {
        return await this._toResourceInternal(dataset, Metamodel.modelFor(CommonDataServiceEntityDataset).name, 'entityName');
    }

    protected async _toModel(modelDatasetResource: Model.DatasetResource, dataset?: CommonDataServiceEntityDataset): Promise<CommonDataServiceEntityDataset> {
        return await this._toModelInternal(modelDatasetResource, dataset, CommonDataServiceEntityDataset.MODEL, 'entityName');
    }
}
